import { motion } from "framer-motion";

/** 007-style countdown ticker — animated numeric stat tiles. */
export function Telemetry({ items }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-neutral-900" data-testid="telemetry">
      {items.map((it, i) => (
        <motion.div
          key={it.label}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.08 }}
          className="bg-black p-6 lg:p-8 flex flex-col justify-between min-h-[140px]"
        >
          <div className="flex items-center justify-between">
            <div className="font-mono text-[9px] tracking-[0.3em] text-neutral-600">{it.code}</div>
            <div className="w-1 h-1 bg-white/40 rounded-full" />
          </div>
          <div>
            <div className="font-bodoni text-5xl md:text-6xl leading-none">{it.value}</div>
            <div className="font-mono text-[10px] tracking-[0.25em] text-neutral-500 mt-2">{it.label}</div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}

/** Radar sweep — pure CSS aerospace radar. */
export function Radar({ size = 200 }) {
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="radar">
      <div className="absolute inset-0 rounded-full border border-neutral-700" />
      <div className="absolute inset-[12%] rounded-full border border-neutral-800" />
      <div className="absolute inset-[28%] rounded-full border border-neutral-800" />
      <div className="absolute inset-[44%] rounded-full border border-neutral-800" />
      <div className="absolute top-1/2 left-0 right-0 h-px bg-neutral-800" />
      <div className="absolute top-0 bottom-0 left-1/2 w-px bg-neutral-800" />
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: "conic-gradient(from 0deg, transparent 0deg, rgba(255,255,255,0.3) 30deg, transparent 60deg)",
          animation: "radar-sweep 4s linear infinite",
        }}
      />
      {/* Blips */}
      {[[35, 40], [60, 70], [25, 65]].map(([x, y], i) => (
        <div
          key={i}
          className="absolute w-1 h-1 bg-white rounded-full"
          style={{ left: `${x}%`, top: `${y}%`, animation: `blip 2s ease-in-out infinite ${i * 0.4}s` }}
        />
      ))}
      <style>{`
        @keyframes radar-sweep { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes blip { 0%, 100% { opacity: 0; } 50% { opacity: 1; } }
      `}</style>
    </div>
  );
}

/** Crosshair targeting reticle. */
export function Reticle({ size = 160 }) {
  return (
    <div className="relative pointer-events-none" style={{ width: size, height: size }} data-testid="reticle">
      <div className="absolute inset-0 rounded-full border border-white/30" />
      <div className="absolute inset-[15%] rounded-full border border-white/20" />
      <div className="absolute top-1/2 left-0 w-4 h-px bg-white" />
      <div className="absolute top-1/2 right-0 w-4 h-px bg-white" />
      <div className="absolute top-0 left-1/2 h-4 w-px bg-white" />
      <div className="absolute bottom-0 left-1/2 h-4 w-px bg-white" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 border border-white rounded-full" />
    </div>
  );
}
